import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class UserRepositoryService extends BaseRepositoryService<
  ModelRegistry['user']
> {
  recordName = 'user';
  implementMethods = ['query', 'findRecord'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/user': UserRepositoryService;
  }
}
